import { CampoSenha } from '../../componentes/layout/campos/CampoSenha'
import { Grid } from '../../componentes/layout/template/Grid'
import { Row } from '../../componentes/layout/template/Row'
import { FormProvider, useFormSistema } from '../../hooks/useForm'
import { useEffect } from 'react'
import { LoginPage } from '../../componentes/layout/template/LoginPage'
import { useNavigate, useParams } from 'react-router-dom'
import { useLoader } from '../../hooks/useLoader'
import { useAPIService } from '../../hooks/useAPIService'
import { trimCampos } from '../../util/funcoesPadrao'
import { toast } from 'react-toastify'

export function FormRedefinirSenha(){
    return (
        <LoginPage>
            <FormProvider idForm="formRedefinirSenha" formLimpo>
                <FormRedefinirSenhaDados />
            </FormProvider>
        </LoginPage>
    )
}

function FormRedefinirSenhaDados(){
    const { setSubmit, carregaForm } = useFormSistema()
    const { showLoader, hideLoader } = useLoader()
    const { post } = useAPIService()
    const { token } = useParams()
    const navigate = useNavigate()

    async function redefinirSenha(values){
        showLoader()
        
        const res = await post('redefinir_senha', trimCampos(values))

        hideLoader()

        if(res){
            toast.success(res.message ?? 'Solicitação enviada com sucesso')
            login()
        }
    }

    function login(){
        navigate('/')
    }

    useEffect(() => {
        carregaForm({
            token: token
        }, true)
        setSubmit(redefinirSenha)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div className="card">
            <div className="card-body login-card-body">
                <p className="login-box-msg">Você está quase lá, vamos redefinir sua senha.</p>
                <CampoSenha classe="mb-3" nome="password" id="password" placeholder="Senha" tamanhoNormal lembrar obrigatorio />
                <CampoSenha classe="mb-3" nome="password_confirmation" id="password_confirmation" placeholder="Confirmar Senha" tamanhoNormal lembrar obrigatorio />
                <Row>
                    <Grid preencher>
                        <button type="submit" className="btn btn-primary btn-block">Redefinir Senha</button>
                    </Grid>
                </Row>
                <p className="mt-3 mb-1">
                    <a href="/" onClick={(event) => {
                        event.preventDefault()
                        login()
                    }}>Login</a>
                </p>
            </div>
        </div>
    )
}